import React from "react";
import GitHubProjects from "./GitHubProjects";

function Projects() {
  return <GitHubProjects />;
}

export default Projects;
